import React from 'react';
import { FlowNode } from '../../../../types/flowBuilder';
import { BaseConfigProps, ConfigSection, ConfigField } from '../shared/ConfigFormHelpers';

interface DebugLoggerConfigProps extends BaseConfigProps {
  node: FlowNode;
  updateConfig: (key: string, value: any) => void;
}

const DebugLoggerConfig: React.FC<DebugLoggerConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <ConfigSection title="Debug napló beállítások">
        <ConfigField
          label="Log szint"
          description="A naplózás részletessége"
        >
          <select
            value={node.data.config?.logLevel || 'info'}
            onChange={(e) => updateConfig('logLevel', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="debug">🔍 Debug - Minden részlet</option>
            <option value="info">ℹ️ Info - Általános információk</option>
            <option value="warn">⚠️ Warning - Figyelmeztetések</option>
            <option value="error">❌ Error - Csak hibák</option>
          </select>
        </ConfigField>

        <ConfigField
          label="Egyéni üzenet"
          description="Opcionális prefix az üzenethez"
        >
          <input
            type="text"
            value={node.data.config?.customMessage || ''}
            onChange={(e) => updateConfig('customMessage', e.target.value)}
            placeholder="Debug pont: Adatok feldolgozása..."
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <ConfigField
          label="Naplózandó mezők"
          description="Vesszővel elválasztva, vagy * az összeshez"
        >
          <input
            type="text"
            value={node.data.config?.fields || '*'}
            onChange={(e) => updateConfig('fields', e.target.value)}
            placeholder="* vagy customer.name, order.total"
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <div className="space-y-2">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="includeTimestamp"
              checked={node.data.config?.includeTimestamp !== false}
              onChange={(e) => updateConfig('includeTimestamp', e.target.checked)}
              className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
            />
            <label htmlFor="includeTimestamp" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Időbélyeg hozzáadása
            </label>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              id="prettyPrint"
              checked={node.data.config?.prettyPrint !== false}
              onChange={(e) => updateConfig('prettyPrint', e.target.checked)}
              className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
            />
            <label htmlFor="prettyPrint" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Formázott JSON kimenet
            </label>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              id="saveToFile"
              checked={node.data.config?.saveToFile || false}
              onChange={(e) => updateConfig('saveToFile', e.target.checked)}
              className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
            />
            <label htmlFor="saveToFile" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Mentés fájlba is (debug.log)
            </label>
          </div>
        </div>
      </ConfigSection>

      <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-md p-3">
        <div className="text-xs text-yellow-700 dark:text-yellow-300">
          <strong>🐛 Debug tippek:</strong>
          <br />• Használd flow fejlesztés közben az adatok ellenőrzésére
          <br />• A naplók az Execution History-ban láthatók
          <br />• Production környezetben távolítsd el vagy állítsd "error"-ra
          <br />• Az adatok áthaladnak változatlanul a következő node-ra
        </div>
      </div>
    </div>
  );
};

export default DebugLoggerConfig;
